import { getBlogPostsList } from '@/api/blog.wp.api'

import union from 'lodash.union'

const state = {
	postsList: [],
	pagesLoaded: [],
	pageSize: 20,
	totalItems: 0,
	loading: true,
	initialLoaded: false
}

const actions = {
	loadInitialPosts: ({ dispatch, commit }) => {
		dispatch('loadPosts', { page: 1 }).then(() => {
			commit('POST_INITIAL_LOADED')
		})
	},
	loadPosts: ({ commit, state }, payload = { page: 1}) => {
		if (state.pagesLoaded.indexOf(payload.page) > -1) return
		commit('POSTS_LIST_LOAD')

		return new Promise((resolve, reject) => {
			getBlogPostsList(payload.page)
				.then((response) => {
					commit('TOTAL_SET', parseInt(response.headers['x-wp-total'], 10))
					commit('POSTS_LIST_SAVE', { posts: response.data, page: payload.page })
					resolve(response)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

const mutations = {
	POSTS_LIST_LOAD: (state) => {
		state.loading = true
	},
	POST_INITIAL_LOADED: (state) => {
		state.initialLoaded = true
	},
	POSTS_LIST_SAVE: (state, payload) => {
		// console.log('save')
		for (var i = 0; i < payload.posts.length; i++) {
			state.postsList[(payload.page - 1) * 20 + i] = payload.posts[i]
		}
		state.pagesLoaded = union(state.pagesLoaded, [payload.page])
		state.loading = false
	},
	TOTAL_SET: (state, total) => {
		state.totalItems = total
	}
}

const getters = {
	blogLoaded: state => !state.loading && state.initialLoaded,
	featuredPosts: state => !state.loading && state.initialLoaded ? [...state.postsList].filter(Boolean).filter(x => !x.sticky).splice(0, 4) : []
}

export default {
	state,
	actions,
	mutations,
	getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/blog.store.js